module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("Three")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-y"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("‘Y")]), _vm._v("ou’re wearing Grapefruit,’ sniffs Sharni. ‘I love Jo Malone.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s one of my few luxuries,’ I say and then realise it sounds like I can’t afford it. The truth is I can’t. My salary as a part-time teacher doesn’t pay that much and although Chris works hard and takes every bit of overtime he can, we don’t have much left over once the mortgage and bills are paid. The Jo Malone perfume was a special treat for my birthday last year and I’m making it last.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Come in,’ Sharni says warmly, taking our coats.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sharni is an excellent hostess. I can’t imagine how she finds the time but I suppose it helps not having children. The table is laid with assorted cheeses, ham, French bread, home-made Melba toast, pates, and small crispbreads topped with smoked salmon and cream cheese. Sharni hands us a mango Bellini while her husband, Tom, offers around a plate of canapés. I tell Sharni I’m not drinking but she’s having none of it and says we’re there to christen the house and what better way to do that than with champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘One won’t hurt,’ Chris whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I’m not at all used to champagne. I can’t remember the last time Chris and I had some. I only ever drink it at weddings and we haven’t been to one of those in a long time. It’s not something we have in the house. A bottle of wine is a treat for us. The truth is I don’t like to mix alcohol with diazepam. It’s not that I can’t. It’s just I don’t want to be incapable of taking care of Ben. Being a mum means everything to me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The house is lovely,’ I say.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’d never think you’d just moved in,’ agrees Chris, looking around.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Tom laughs. He’s good looking. Not the kind of man I would have imagined Sharni to be with. He’s dynamic and stands out whereas Sharni seems insignificant with her mousy brown hair and glasses. Tom has a very upper-crust accent, unlike Sharni who has a West Country lilt to her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You haven’t seen the upstairs. Everything that hasn’t been unpacked is up there,’ says Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He tops up my Bellini before I can stop him. Chris and I sit together on the white sofa. It feels hard and resistant beneath me, unlike our old saggy one where my body moulds into its softness. Sharni looks less tired than when I last saw her. Her hair is tidier and tied back into a neat bun. Large black dangly earrings hang from her ears.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There are ‘Good Luck’ cards on the windowsill. I’ve never been in the house before. An elderly couple lived here previously. I’d heard the work being done before Sharni and Tom moved in. The lounge wall is covered in black and white photos. Several are of Tom in a natural pose. I wonder if he’s a model. He clearly knows how to pose for photographs. Alongside those are colour prints of another couple, older than us and I presume them to be Sharni or Tom’s parents. Others are of country landscapes and the rest are of Sharni and Tom in loving poses. I stand up and study them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nice photos,’ I say, feeling the champagne relax me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I feel Sharni at the side of me and sniff her perfume. It smells of lemons.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I took them,’ she says, pouring champagne into my glass.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You did?’ says Chris. ‘They’re brilliant.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Oh, no more,’ I say, covering the glass with my hand. ‘I really can’t be drunk in charge of a two-year-old.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re not with him now,’ she says, removing my hand. ‘I could take some photos of Ben if you like?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I start at Ben’s name. I don’t remember telling her his name was Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re a good photographer,’ I say.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I’m beginning to feel heady.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She should be. It’s her job,’ laughs Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Really?’ says Chris. ‘Who do you work for?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Chris is a town planner. He’s always taking photos of roads. You know, for road improvements,’ I say, taking a Melba toast. The champagne is beginning to make my head spin.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s not quite the same,’ says Chris and for a moment I feel stupid and hate him for making me feel that way.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m freelance,’ says Sharni, helping herself to a salmon crispbread. ‘I take fashion photos. I design the sets for fashion shoots. I do a lot of work for "), _c('i', [_vm._v("Vogue")]), _vm._v(", do you know it? I have a studio in their London offices.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But mostly she gets to work from home, the lucky woman,’ says Tom, kissing her lovingly on the cheek. ‘Town planning, that’s interesting,’ he adds, turning to Chris.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I can’t help thinking there’s a patronising tone in his voice. I turn away and study the photos.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘These are excellent,’ I say and wonder if my speech is slurred.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It would be great to have a professional photo of Ben,’ says Chris. ‘Wouldn’t it Clare?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’d be happy to take photos of him,’ says Sharni.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I watch in surprise as Tom uncorks another bottle of champagne. I don’t think Chris and I have ever got through a whole bottle of wine in an evening let alone two bottles of champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What do you do Clare?’ Tom asks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m a school teacher. I only do two days a week now.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She helps at the local nursery too,’ adds Chris and I feel stupidly embarrassed that I don’t have a high-powered job like Sharni’s.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That must be great for Ben,’ says Sharni, but her voice sounds hollow.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We like to get involved,’ says Chris. ‘We’re key holders too so should there ever be a problem we’re the first on the list.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I roll my eyes at Chris. He’s going over the top trying to impress them for some reason.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Lucky you,’ says Tom, clinking my glass with his. ‘I feel like I do eight days a week.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Tom’s a barrister, so it never really stops,’ groans Sharni.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That must be really interesting,’ says Chris and I feel a spark of irritation. Does he have to suck up to them? After all, their house isn’t much bigger than ours. In fact, I’m beginning to wonder, if they’re doing that well, why are they living here at all?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Clare is brilliant at interior design,’ says Sharni.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, I’m not really,’ I protest.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re too modest.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll get some beers,’ says Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll get them,’ Sharni says, taking me by the arm. ‘I want to show Clare the kitchen.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I glance down at my bag. I really should check my phone just in case Kathryn has texted. I’m pulled into a surprisingly messy kitchen. Used oven dishes clutter the counter along with empty packets of smoked salmon. Sharni peeks into the shiny new Aga.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Can you pass the oven glove?’ she asks. ‘It’s with the dishes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I turn to get the glove and stare at a crystal vase on the window sill. It’s full of flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Is it not there?’ she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Oh yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She slams a tray of tartlets on to the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘God, that’s hot.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I wonder if I should ask for my vase. She clearly doesn’t need it, but I don’t want to seem petty. I’ll wait until we leave. She’s no doubt got it somewhere ready to give me, when we do.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The kitchen’s a bit of a tip, I know. I thought I’d wallpaper, what do you think? I really value your opinion.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I think wallpaper would be nice.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m not sure. Paint is so much easier.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes, our kitchen is painted.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you want a beer?’ she asks, opening the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shake my head.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Perhaps we could go to Liberty’s together, take a look at the wallpapers. How about Monday? You don’t work Mondays do you?’ she says excitedly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I stare at her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How do you know I don’t work Mondays?’ I hear the sharpness in my voice and regret it. She doesn’t seem to notice and says,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It was Monday when we moved in. You were home. I just presumed you don’t work on a Monday.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Oh, of course, I forgot.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We could do lunch too,’ she says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll have Ben,’ I remind her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s okay. It’ll be great to take Ben out. I can take some photos of him. Kill two birds with one stone.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well …’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Before I realise, she has topped up my glass with champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Let’s get these beers to the guys,’ she says.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("It’s almost eleven. I’d promised Kathryn we wouldn’t be later than ten-thirty but it’s beginning to feel like the evening has only just started.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Should I phone Kathryn?’ I ask Chris. ‘Tell her we’ll be a bit later. Check it is okay?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sure it will be but yes, give her a bell.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Can I use your loo?’ I ask Sharni.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sure,’ she says. ‘It’s upstairs, first on the left.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I search in my bag for my phone. My eyes are blurry and I’m finding it difficult to see.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’ve dropped something,’ says Chris.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My hand finally lands on the phone and I pull it out of the jumbled mess in my handbag along with numerous bits of make-up. Sharni must think I’m so disorganised.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I climb the stairs carefully, my head spinning from the alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘There’s no light bulb,’ Sharni calls as I reach the top. ‘Turn the lamp on.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I fumble around the little table on the landing until I feel the lamp. The soft light illuminates the landing. The lamp is identical to ours. It’s the one Sharni admired in our lounge.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I got it in John Lewis.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her voice makes me jump.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sorry did I scare you?’ she says from behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s okay,’ I say shakily.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I hope you don’t mind. I love it so much. I thought I’d put it up here.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m flattered,’ I smile.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You girls okay up there? I’m making coffee,’ calls Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Clare just saw our new lamp,’ smiles Sharni.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You shouldn’t have such good taste Clare,’ says Tom. ‘Do you want a coffee?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m fine,’ I say, ‘we really should be going.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I find the bathroom and step inside. Sharni must think I’m a right neurotic. I have to admit that I feel a bit annoyed about the vase but she’s probably been rushed off her feet and has forgotten all about it. I’ll ask for it in a few days. It’s nice to be admired though. I can’t remember when anyone has admired my ideas. Chris had never liked the lamp. I feel vindicated. It will be nice to go shopping with someone who has the same taste as me. It will be fun.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The bathroom is new. Shiny and squeaky clean, unlike ours with towels strewn everywhere. Here, the towels are neatly folded over a rail.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thanks for a great night,’ says Chris, kissing Sharni on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It’s eleven-thirty and I’m feeling quite anxious about Ben. I’ve never left him this long with Kathryn before.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We must do it again,’ says Tom, hugging me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll see you Monday,’ says Sharni, giving me a hug. Her lemon fragrance washes over me. ‘I can’t wait. I’ve got some great ideas for the house.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You must come to us next time,’ says Chris. ‘Come for dinner.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We wave and Chris supports me by the arm.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve drunk too much,’ I say.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Good. I’ll take advantage of you,’ he laughs. ‘Did you ask about the vase?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I forgot.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He squeezes my bum.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll get a taxi for Kathryn,’ he whispers. ‘And see you upstairs.’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("‘How have you been feeling this week?’ Leah asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("The tissue box is flowery this time. She wondered if Leah’s other clients cried more than her. Do they relive their nightmares and hellish days in this room too? She sat with her hands in her lap and looked down at her bitten nails.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘The same,’ she said flatly.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘Are the pills the doctor gave you helping?’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She sighed and looked to the floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I don’t like taking them,’ she said. ‘They make me forget things and I don’t want to forget …’ she trailed off.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘No one wants you to forget,’ Leah said softly, ‘but we want you to heal. It’s been nine months. It’s important you help the healing process.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("The tears sprang to her eyes and ran down her cheeks. She didn’t try to conceal them instead she demolished the flowery tissue box.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘How are things at home?’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Empty, everything at home feels empty.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘He’s understanding and tries to be very caring.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Leah nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘He’s suffering too. I know that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She blew noisily into the tissue.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("But he’s let me down, she thought. They’ve all let me down.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I have to go,’ she said getting up.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘You’ve only just arrived,’ Leah said, but her voice was resigned.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I’m not ready,’ she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She doesn’t think she’ll ever be ready.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6afc24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 81
// module chunks = 0